__turbopack_context__.v({
  "modal": "PlaceCardDialog-module__SHjUKa__modal",
  "modal-fade": "PlaceCardDialog-module__SHjUKa__modal-fade",
  "modalReview": "PlaceCardDialog-module__SHjUKa__modalReview",
});
